import API from "serviceshift-ui/api-client";
import { resetCollection, setCollectionItem } from "@/lib/collections";

import { AccountingClass } from "@/typings/accounting";

export default {
  fetchAccountingClasses() {
    return API.makeRequest("/v2/accounting_classes", {
      method: "GET"
    }).then((response) => {
      resetCollection("accountingClasses");

      response.data.forEach((item: Partial<AccountingClass>) => {
        const typedItem = new AccountingClass(item);
        setCollectionItem("accountingClasses", item.id!, typedItem);
      });
    });
  },
  verifyAccountingClasses() {
    return API.makeRequest("/v2/accounting_classes/verify", {
      method: "PUT"
    });
  },
  createAccountingClass(_, data) {
    return API.makeRequest("/v2/accounting_classes", {
      method: "POST",
      data
    });
  },
  updateAccountingClass(_, { accounting_class }) {
    return API.makeRequest(`/v2/accounting_classes/${accounting_class.id}`, {
      method: "PUT",
      data: { accounting_class }
    });
  },
  updateInvoiceAccountingClass(_, { invoiceId, accounting_class_id }) {
    return API.makeRequest(`/v2/invoices/${invoiceId}/accounting_class`, {
      method: "PUT",
      data: { accounting_class_id }
    });
  },
  deleteAccountingClass(_, id) {
    return API.makeRequest(`/v2/accounting_classes/${id}`, {
      method: "DELETE"
    });
  },
  async archiveAccountingClass({ dispatch }, accountingClass: AccountingClass) {
    await API.makeRequest(accountingClass.links.archive, { method: "PUT" });
    dispatch("fetchAccountingClasses");
  },
  async unarchiveAccountingClass(
    { dispatch },
    accountingClass: AccountingClass
  ) {
    await API.makeRequest(accountingClass.links.unarchive, { method: "PUT" });
    dispatch("fetchAccountingClasses");
  }
};
